import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import ScrollMagic from "scrollmagic";
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
import isMobile from '../common/is-mobile.js';


var controller = new ScrollMagic.Controller();




// TweenMax.to($(".top-hero-content__periodText"), 0.7, {
//   bezier:[
//     {right:25, top:-20}
//   ],
//   ease:Power1.easeInOut
// });
var period_text_right = !isMobile(767) ? 19 : 6;
var period_text_top = !isMobile(767) ? 13 : -20;

var tl_hero = new TimelineMax();

tl_hero
.to($(".top-hero__bg"), 0.7, {
  width: "100%",
  delay: 0.8,
  ease:Power1.easeInOut
})
.to($(".top-hero-logo"), 0.7, {
  alpha: 1,
  y: "0",
  delay: 0.3
})
// .to($(".top-hero-content__periodText"), 0.7, {
//   bezier:[
//     {right: period_text_right + "%", top: period_text_top + "px"}
//   ],
//   delay: -0.4,
//   // ease:Power1.easeIn
// })
.staggerTo($(".top-hero-present__item"), 0.7, {
  y: "0",
  alpha: 1,
  delay: 0.2
}, 0.2)
.to($(".top-hero-button__inner "), 0.5, {
  y: "0",
  alpha: 1,
  delay: -0.2
})




//campaign01
var scene_mycoin = new ScrollMagic.Scene({
  triggerElement: ".p-section-body.-campaign01" ,
  triggerHook: 'onCenter',
  // duration: 800,
  offset :0
})
// .addIndicators()
.addTo(controller);

scene_mycoin.on('enter', ()=>{
  var tl = new TimelineMax();

  tl
  .to($(".p-section-body.-campaign01"), 0.6, {
    y: "0",
    alpha: 1
  })
//triggerElementを過ぎたとき
});

//campaign02
var scene_mycoin = new ScrollMagic.Scene({
  triggerElement: ".p-section-body.-campaign02" ,
  triggerHook: 'onCenter',
  // duration: 800,
  offset :0
})
// .addIndicators()
.addTo(controller);

scene_mycoin.on('enter', ()=>{
  var tl = new TimelineMax();

  tl
  .to($(".p-section-body.-campaign02"), 0.6, {
    y: "0",
    alpha: 1
  })
//triggerElementを過ぎたとき
});







//申し込みボタン
var scene_fixed_button = new ScrollMagic.Scene({
  triggerElement: ".js-fixedButton-show" ,
  triggerHook: 'onLeave',
  // duration: 800,
  offset :0
})
// .addIndicators()
.addTo(controller);

scene_fixed_button.on('enter', ()=>{
  $(".top-fixedButton").addClass("is-open");
});
scene_fixed_button.on('leave', ()=>{
  $(".top-fixedButton").removeClass("is-open");
});




